import tw, { styled } from 'twin.macro';

export const EmployerPageContentWrapper = styled.div`
  ${tw`py-[63px] xl:py-[80px] px-4 lg:px-10 xl:px-20 max-w-screen-xl mx-auto`}
`;
